import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InventoryGoodsIssueAdjustmentIssueDateEarlierThanAdjustedError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.inventory.goods-issue-adjustment.validation.issue-date.earlier-than-adjusted');
    }
}
